/**
 * @generated SignedSource<<00214681a40d32d6b7189a599467c74d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_SlotsPage_Query$variables = {
  studyId: string;
};
export type RouteConfig_SlotsPage_Query$data = {
  readonly viewer: {
    readonly languages: ReadonlyArray<{
      readonly code: string;
      readonly name: string;
    } | null>;
    readonly study: {
      readonly " $fragmentSpreads": FragmentRefs<"SlotsPage_study">;
    } | null;
  };
};
export type RouteConfig_SlotsPage_Query = {
  response: RouteConfig_SlotsPage_Query$data;
  variables: RouteConfig_SlotsPage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "studyId",
    "variableName": "studyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageNode",
  "kind": "LinkedField",
  "name": "languages",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "availabilityBuffer",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "InterviewerNode",
  "kind": "LinkedField",
  "name": "interviewer",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "inPerson",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLink",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingLocation",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingDetails",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placesLimit",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countOfBookedSlots",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventsType",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_SlotsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SlotsPage_study"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_SlotsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "StudyNode",
            "kind": "LinkedField",
            "name": "study",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyAvailabilitySlotConnection",
                "kind": "LinkedField",
                "name": "availabilitySlots",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyAvailabilitySlotEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudyAvailabilitySlotNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TenantNode",
                "kind": "LinkedField",
                "name": "tenant",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCalendlyIntegration",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "vpmAccountId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "schedulingLink",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "approvedCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "voxpopmeRecorderEnabled",
                "storageKey": null
              },
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canHaveMultipleSessions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StudySessionNodeConnection",
                "kind": "LinkedField",
                "name": "sessions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudySessionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StudySessionNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v7/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                            "kind": "LinkedField",
                            "name": "availabilitySlots",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StudyAvailabilitySlotNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v9/*: any*/),
                                      (v15/*: any*/),
                                      {
                                        "alias": "_value",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "meetingDetails",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "StudySessionNode",
                                        "kind": "LinkedField",
                                        "name": "session",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StudyNode",
                                            "kind": "LinkedField",
                                            "name": "study",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v16/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "StudySessionNodeConnection",
                                                "kind": "LinkedField",
                                                "name": "sessions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "StudySessionNodeEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "StudySessionNode",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v4/*: any*/),
                                                          (v2/*: any*/),
                                                          (v7/*: any*/),
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "StudyAvailabilitySlotNodeConnection",
                                                            "kind": "LinkedField",
                                                            "name": "availabilitySlots",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "alias": null,
                                                                "args": null,
                                                                "concreteType": "StudyAvailabilitySlotNodeEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "StudyAvailabilitySlotNode",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v4/*: any*/),
                                                                      (v5/*: any*/),
                                                                      (v6/*: any*/),
                                                                      (v7/*: any*/),
                                                                      (v9/*: any*/),
                                                                      (v10/*: any*/),
                                                                      (v13/*: any*/),
                                                                      (v11/*: any*/),
                                                                      (v12/*: any*/),
                                                                      (v14/*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                  }
                                                                ],
                                                                "storageKey": null
                                                              }
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3369f429b243fd8b343f49007f33eaa5",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_SlotsPage_Query",
    "operationKind": "query",
    "text": "query RouteConfig_SlotsPage_Query(\n  $studyId: String!\n) {\n  viewer {\n    study(studyId: $studyId) {\n      ...SlotsPage_study\n      id\n    }\n    languages {\n      name\n      code\n    }\n  }\n}\n\nfragment InputSlotDetails_slot on StudyAvailabilitySlotNode {\n  id\n  _value: meetingDetails\n  session {\n    study {\n      id\n      eventsType\n      sessions {\n        edges {\n          node {\n            id\n            name\n            duration\n            availabilitySlots {\n              edges {\n                node {\n                  id\n                  start\n                  end\n                  duration\n                  interviewer {\n                    email\n                    id\n                  }\n                  inPerson\n                  meetingDetails\n                  meetingLink\n                  meetingLocation\n                  placesLimit\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment SessionsForm_FocusGroupSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_InterviewSlotEditor_slot on StudyAvailabilitySlotNode {\n  countOfBookedSlots\n  ...InputSlotDetails_slot\n}\n\nfragment SessionsForm_study on StudyNode {\n  id\n  dId\n  type\n  eventsType\n  status\n  approvedCount\n  tenant {\n    vpmAccountId\n    id\n  }\n  canHaveMultipleSessions\n  sessions {\n    edges {\n      node {\n        id\n        name\n        duration\n        countOfBookedSlots\n        availabilitySlots {\n          edges {\n            node {\n              id\n              start\n              end\n              availabilityBuffer\n              duration\n              inPerson\n              meetingLink\n              meetingLocation\n              meetingDetails\n              placesLimit\n              interviewer {\n                email\n                id\n              }\n              ...SessionsForm_FocusGroupSlotEditor_slot\n              ...SessionsForm_InterviewSlotEditor_slot\n            }\n          }\n        }\n      }\n    }\n  }\n  voxpopmeRecorderEnabled\n}\n\nfragment SlotsPage_study on StudyNode {\n  id\n  dId\n  type\n  status\n  availabilitySlots {\n    edges {\n      node {\n        id\n        start\n        end\n        duration\n        availabilityBuffer\n        interviewer {\n          email\n          id\n        }\n        inPerson\n        meetingLink\n        meetingLocation\n        meetingDetails\n        placesLimit\n        countOfBookedSlots\n      }\n    }\n  }\n  tenant {\n    enableCalendlyIntegration\n    id\n  }\n  availabilityBuffer\n  schedulingType\n  schedulingLink\n  meetingLink\n  approvedCount\n  voxpopmeRecorderEnabled\n  ...SessionsForm_study\n}\n"
  }
};
})();

(node as any).hash = "c1938db91061705a2564f68f42f3c4a5";

export default node;
